import {
	Component,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges,
} from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { CGIService } from './../../../promptuary/services/cgi/cgi.service';

@Component({
	selector: 'contacts-table-baseline-filter',
	templateUrl: './contacts-table-baseline-filter.component.html',
	styleUrls: ['./contacts-table-baseline-filter.component.scss'],
})
export class ContactsTableBaselineFilterComponent implements OnInit, OnChanges {
	@Input()
	professionalType: string;

	@Input()
	formGroup: FormGroup;

	type: 'life_quality' | 'clinical_severity';
	options = [];
	formArray: FormArray;

	constructor(public cgiService: CGIService) {}

	ngOnInit(): void {
		this.formArray = this.formGroup.get('levels') as FormArray;
		this.getOptions();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.professionalType) {
			this.type =
				this.professionalType === 'psychologist' ||
				this.professionalType === 'psychiatrist'
					? 'clinical_severity'
					: 'life_quality';
		}
	}

	getOptions() {
		this.cgiService
			.getBaselineLevels()
			.toPromise()
			.then((res) => {
				this.options = res;
			});
	}

	onCheckChange(event) {
		if (event.$event.checked) {
			this.formArray.push(new FormControl(event.value));
		} else {
			let i = 0;

			this.formArray.controls.forEach((ctrl: FormControl) => {
				if (ctrl.value == event.value) {
					this.formArray.removeAt(i);
					return;
				}
				i++;
			});
		}
	}

	isChecked(level) {
		return this.formArray.controls.some((control) => control.value === level);
	}
}
